export default __webpack_public_path__ + "static/media/Megosu - Lukas Bazle - 1.060f6734.jpg";